import reduxFetch from 'react-redux-fetch';
import { COMMUNITY_ONBOARDING_TEMPLATE_RESOURCE } from '../constants';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_ONBOARDING_TEMPLATE_RESOURCE,
      method: 'get',
      request: id => ({
        url: apiRoutes.onboardingTemplates(id),
      }),
    },
  ])(ComposedComponent);
